/*
 * @Author: 彭梦婷
 * @Date: 2025-09-16 10:46:51
 * @LastEditors: 彭梦婷
 * @LastEditTime: 2026-08-20 10:42:47
 * @Description: 
 * @FilePath: \company-web\src\api\api.js
 */
import axios from 'axios';

// 创建 Axios 实例，配置基础URL等
const api = axios.create({
  // baseURL: 'http://192.168.31.156:8083',
  baseURL: 'https://www.baoyanbd.com/prod-api',//正式环境
  //  baseURL: 'https://baoyan.whha666.com/test-api',//测试环境
  timeout: 1000 * 60 * 60,  // 设置请求超时时间
});

// 添加请求拦截器（可选）
api.interceptors.request.use(
  config => {
    // 在请求发送前可以做一些操作，例如添加认证 token
    // config.headers['Authorization'] = 'Bearer your-token';
     if (config.data instanceof FormData) {
      config.headers['Content-Type'] = 'multipart/form-data';
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 添加响应拦截器（可选）
api.interceptors.response.use(
  response => {
    // 对响应数据进行处理
    return response.data;
  },
  error => {
    return Promise.reject(error);
  }
);

export {api};
// export default api;
